// extracted by mini-css-extract-plugin
export var aiStarIcon = "_74-4";
export var closeButton = "_74-6";
export var dismissButton = "_74-3";
export var editImageWithAiContainer = "_74-8";
export var imageUploadWrapper = "_74-7";
export var misspelledWord = "_74-5";
export var spellCheckContainer = "_74-2";
export var spin = "_74-1";
export var spinning = "_74-0";